"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardContext = void 0;
var _react = require("react");
var WizardContext = /*#__PURE__*/(0, _react.createContext)({
  step: 0,
  setStep: function setStep() {}
});
exports.WizardContext = WizardContext;